import { Box, styled } from '@mui/material'
import { Attribute, AttributeLabel, AttributeValue } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'

const StyledAttribute = styled(Attribute)(({ theme, styles }) => ({
    marginTop: '-0.8rem',
    ...styles?.attribute,
}))

const PolicyDetails = ({
    policy,
    orientation = 'horizontal',
    showValuesIfUnrestricted = true,
    styles,
}) => {
    const StyledAttributeValue = styled(AttributeValue)(({ theme }) => ({
        wordBreak: 'unset',
        ...styles?.attributeValue,
    }))

    const StyledAttributeLabel = styled(AttributeLabel)(({ theme }) => ({
        minWidth: '26.5rem',
        ...styles?.attributeLabel,
    }))

    const { t } = useTranslation()
    return (
        <Box>
            <StyledAttribute orientation={orientation}>
                <StyledAttributeLabel>
                    {t('AccessRequestPolicy')}
                </StyledAttributeLabel>
                <StyledAttributeValue>
                    {policy && policy.friendlyName}
                </StyledAttributeValue>
            </StyledAttribute>
            <StyledAttribute orientation={orientation}>
                <StyledAttributeLabel>
                    {t('AllowsTimeConstrainedAccess')}
                </StyledAttributeLabel>
                <StyledAttributeValue>
                    {policy && policy.isTimeConstrained ? t('Yes') : t('No')}
                </StyledAttributeValue>
            </StyledAttribute>
            {(showValuesIfUnrestricted || policy.isTimeConstrained) && (
                <>
                    <StyledAttribute orientation={orientation}>
                        <StyledAttributeLabel>
                            {t('DefaultAccessDuration')}
                        </StyledAttributeLabel>
                        <StyledAttributeValue>
                            {policy && policy.defaultValueInMinutes}
                        </StyledAttributeValue>
                    </StyledAttribute>
                    <StyledAttribute orientation={orientation}>
                        <StyledAttributeLabel>
                            {t('MaxAccessDuration')}
                        </StyledAttributeLabel>
                        <StyledAttributeValue>
                            {policy && policy.maximumValueInMinutes}
                        </StyledAttributeValue>
                    </StyledAttribute>
                </>
            )}
        </Box>
    )
}

export default PolicyDetails
